export default "__VITE_ASSET__DD5dxrwB__"